import React from 'react';

const RadioButton = props => {
  return (
      <p className="radio-wrapper">
        <label>
          <input className="with-gap"
                 name={props.name}
                 value={props.value}
                 type="radio"
                 defaultChecked={props.defaultChecked}
                 onChange={props.onChange}
                 data-type={props.type}/>
          <span className="radio-span">{props.spanText}</span>
        </label>
      </p>
  );
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/RadioButton/RadioButton.js